import {useContext} from "react";
import GlobalContext         from "../../../isp._comun/iu/contexto/GlobalContext";
// import AbrirVentana from "../../reductores/acciones/widgets/AbrirVentana";
import VentanaContrato       from '../../../isp.iu.contratos/reductores/ventanas/VentanaContrato'
import VentanaQueryContratos from '../../../isp.iu.contratos/reductores/ventanas/VentanaQueryContratos'

export default function MenuItemsContratos() {
    const {
        abrirVentana
    } = useContext(GlobalContext);
    return [
        
        {
            label: "Nuevo Contrato",
            icon: "pi pi-fw pi-plus",
            command: () => {
                const nuevaVentana = VentanaContrato.nuevaVentanaEnModoCrear();
                abrirVentana(nuevaVentana);
            },
        },
        {
            label: "Listar Contratos",
            icon: "pi pi-fw pi-list",
            command: () => {
                const nuevaVentana = new VentanaQueryContratos();
                abrirVentana(nuevaVentana);

                // dispatchPrincipal(new AbrirVentana(nuevaVentana));
                // dispatch(new AbrirVentanaQueryClientesAFacturar())
            },
        },
    ];
}

